import { MenuProps } from "antd";
import { useMemo } from "react";
import { DropdownOptionsActionsProps } from "../components/DropdownOptionsActions";
import { useRole } from "../../../../features/roles/useRole";

export default function useDropdownItems({
  itemId,
  onModify,
  onDelete,
  goToDetails,
  iAmTheAssignedPilote,
}: DropdownOptionsActionsProps) {
  const { isPilote, isAdmin } = useRole();
  const items = useMemo(() => {
    const _items: MenuProps["items"] = [
      {
        key: "1",
        label: (
          <a
            onClick={(e) => {
              e.stopPropagation();
              goToDetails(itemId);
            }}
          >
            Voir l'action
          </a>
        ),
      },
    ];

    if (isPilote) {
      _items.push({
        key: "2",
        label: (
          <a
            onClick={(e) => {
              e.stopPropagation();
              onModify(itemId);
            }}
          >
            Modifier l&apos;action
          </a>
        ),
      });

      if (isAdmin || iAmTheAssignedPilote) {
        _items.push({
          key: "3",
          danger: true,
          label: (
            <a
              onClick={(e) => {
                e.stopPropagation();
                onDelete(itemId);
              }}
            >
              Supprimer
            </a>
          ),
        });
      }
    }

    return _items;
  }, [
    isPilote,
    goToDetails,
    itemId,
    isAdmin,
    iAmTheAssignedPilote,
    onModify,
    onDelete,
  ]);
  return items;
}
